/* @flow */
// typecheck: ignore file
import type { Action } from 'action';
import { List, Map } from 'immutable';

export type Step = {
  index: number,
  text: string,
  title: string,
  name: string,
  selector: string
};

export type Ride = {
  allowedToStart: boolean,
  onStart: Function,
  steps: List<Step>,
};

export type RideName = string;
export type Rides = Map<RideName, Ride>;
export type State = Rides;
export const initialState: State = new Map();

function newRide() {
  return {
    steps: new List(),
    onStart: () => {},
    allowedToStart: false,
  };
}

export default function reducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case 'joyrides/ADD_STEP': {
      let ride = state.get(action.ride) || newRide();
      ride = { ...ride, steps: ride.steps.insert(action.step.index, action.step) };
      return state.set(action.ride, ride);
    }

    case 'joyrides/ALLOW_RIDE_TO_START': {
      let ride = state.get(action.ride) || newRide();
      ride = { ...ride, allowedToStart: true, onStart: action.onStart };
      return state.set(action.ride, ride);
    }

    default:
      return state;
  }
}

type AllowRideToStartAction = {
  type: 'joyrides/ALLOW_RIDE_TO_START',
  onStart: Function,
  ride: string,
};

export function allowRideToStart(ride: RideName, onStart: Function): AllowRideToStartAction {
  return {
    type: 'joyrides/ALLOW_RIDE_TO_START',
    onStart,
    ride,
  };
}

type AddStepAction = {
  type: 'joyrides/ADD_STEP',
  ride: RideName,
  step: Step,
};

export function addStep(ride: RideName, step: Step): AddStepAction {
  return {
    type: 'joyrides/ADD_STEP',
    ride,
    step,
  };
}

export type JoyrideActions =
  AllowRideToStartAction |
  AddStepAction;



// WEBPACK FOOTER //
// ./src/reducers/joyrides.js